import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { GET_MEMBERS_GIFT_ITEM_API } from "@apis/apiPath";
import { checkResponse } from "@apis/utils";

const useMemberGiftItemApi = () => {
	const Ajax = useAjax();

	const getMemberGiftItemApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_MEMBERS_GIFT_ITEM_API(memberID));
			if (checkResponse(resp)) return resp;
			return false;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getMemberGiftItemApi,
	};
};

export default useMemberGiftItemApi;
